import { AnyAction } from '@reduxjs/toolkit';
import React, { createContext, ReactNode, useReducer, useContext } from 'react';

import reducer, { actions, State, initialState } from './TypeformNavReducer';

type Action = () => Promise<void> | void | null;

const setNavBarProps =
  (dispatch: React.Dispatch<AnyAction>) =>
  (
    isNextDisabled: boolean,
    isPrevDisabled: boolean,
    onNextClick: Action = () => undefined,
    onPrevClick: Action = () => undefined
  ) => {
    dispatch(actions.setActivePageOnNextClick(onNextClick));
    dispatch(actions.setActivePageOnPrevClick(onPrevClick));
    dispatch(actions.setActivePageNextDisabled(isNextDisabled));
    dispatch(actions.setActivePagePrevDisabled(isPrevDisabled));
  };

const TypeformNavContext = createContext<
  | {
      state: State;
      dispatch: React.Dispatch<AnyAction>;
      setNavBarProps: ReturnType<typeof setNavBarProps>;
    }
  | undefined
>(undefined);

export function TypeformNavProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <TypeformNavContext.Provider
      value={{ state, dispatch, setNavBarProps: setNavBarProps(dispatch) }}
    >
      {children}
    </TypeformNavContext.Provider>
  );
}

export default function useTypeformNavContext() {
  const context = useContext(TypeformNavContext);
  if (context === undefined) {
    throw new Error(
      'useTypeformNavContext must be used within a TypeformNavContext.Provider'
    );
  }
  return context;
}
